import React from "react";
import { GridColumn, GridContainer, GridRow, Img } from "arv-reactcomponents";
import {
  OrderConfirmation,
  HIDE_BRANDNAME,
  Endpoints,
} from "npmlinks-constants";
import PropTypes from "prop-types";
import { ToCurrency } from "../../../../utils";

const { ORDERCONFIRMPAGE } = OrderConfirmation;

const isDiscountedItem = (mrp, sp) => mrp !== sp;

const ProductDetailsBlock = props => {
  const { products, shippingMethod } = props;
  return (
    <GridContainer className="nw-orderconfirm-productdetails-block">
      <GridRow>
        <GridColumn className="nwc-grid-col-sm-5">
          <span className="nw-orderconfirm-productdetails-title">
            {ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.TITLE}
          </span>
        </GridColumn>
        <GridColumn className="nwc-grid-col-sm-5 nw-desktop-only">
          <span className="nw-orderconfirm-productdetails-title">
            {ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.STATUS_TITLE}
          </span>
        </GridColumn>
        <GridColumn className="nwc-grid-col-sm-2 nw-desktop-only">
          <span className="nw-orderconfirm-productdetails-title">
            {ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.PRICE_TITLE}
          </span>
        </GridColumn>
      </GridRow>
      {products.map(item => (
        <GridRow
          className="nw-orderconfirm-productdetails-info-row"
          key={item.skuId}
        >
          <GridColumn className="nwc-grid-col-sm-5">
            <GridRow>
              <GridColumn className="nwc-grid-col-xs-5 nwc-grid-col-sm-4">
                <a href={item.url} target="_blank">
                  <Img
                    className="nw-orderconfirm-productdetails-image"
                    src={item.image || Endpoints.noImg}
                    alt={ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.NO_IMAGE_TEXT}
                  />
                </a>
              </GridColumn>
              <GridColumn className="nwc-grid-col-xs-7 nwc-grid-col-sm-8 nw-orderconfirm-productdetails-info-col">
                {!HIDE_BRANDNAME && (
                  <span className="nw-orderconfirm-productdetails-info-cols-font-family nw-orderconfirm-productdetails-info-span">
                    {item.brand}
                  </span>
                )}
                <span className="nw-orderconfirm-productdetails-info-cols-font-family nw-orderconfirm-productdetails-info-span">
                  {item.description}
                </span>
                <span className="nw-orderconfirm-productdetails-info-span">
                  {ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.QTY}: {item.quantity}
                </span>
                <span className="nw-orderconfirm-productdetails-info-span">
                  {ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.SIZE}: {item.size}
                </span>
                <span className="nw-orderconfirm-productdetails-info-span">
                  {ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.COLOR}: {item.color}
                </span>
                {isDiscountedItem(item.mrp, item.discountedPrice) ? (
                  <div>
                    <span>{ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.PRICE}:</span>
                    <span className="nw-productdetails-discountonmrp">
                      {ToCurrency(item.mrp)}
                    </span>
                    <span className="nw-productdetails-sellingprice">
                      {ToCurrency(item.discountedPrice)}
                    </span>
                  </div>
                ) : (
                  <span className="nw-orderconfirm-productdetails-info-span">
                    {ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.PRICE}:{" "}
                    {ToCurrency(item.mrp)}
                  </span>
                )}
                <span className="nw-orderconfirm-productdetails-info-span nw-mobile-only">
                  {
                    ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.SHIPPING_METHOD[
                      shippingMethod
                    ]
                  }
                </span>
                <span className="nw-orderconfirm-productdetails-info-span nw-orderconfirm-productdetails-exp-date nw-mobile-only">
                  {item.expectedDateText}
                </span>
              </GridColumn>
            </GridRow>
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-5 nw-orderconfirm-productdetails-info-col nw-desktop-only">
            <span className="nw-orderconfirm-productdetails-info-span">
              {
                ORDERCONFIRMPAGE.PRODUCT_DETAILS_BLOCK.SHIPPING_METHOD[
                  shippingMethod
                ]
              }
            </span>
            <span className="nw-orderconfirm-productdetails-info-span nw-orderconfirm-productdetails-exp-date">
              {item.expectedDateText}
            </span>
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-2 nw-orderconfirm-productdetails-info-col nw-desktop-only">
            <span className="nw-orderconfirm-productdetails-info-span">
              {ToCurrency(item.discountedPrice)}
            </span>
          </GridColumn>
        </GridRow>
      ))}
    </GridContainer>
  );
};

ProductDetailsBlock.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  shippingMethod: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductDetailsBlock,
  component: ProductDetailsBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/OrderConsignmentsBlock/ProductDetailsBlock/index.js